import { Link } from 'react-router-dom';
import DropdownUser from '../../components/DropdownUser';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import { useTranslation } from 'react-i18next';

const Header = (props: {
  sidebarOpen: string | boolean | undefined;
  setSidebarOpen: (arg0: boolean) => void;
}) => {
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 z-50 flex w-full bg-white drop-shadow-sm border-b border-gray-100">
      <div className="flex flex-grow items-center justify-between py-2.5 px-3 sm:px-4 md:px-6 2xl:px-11">
        {/* Left Side: Hamburger Menu & Mobile Logo */}
        <div className="flex items-center gap-2 sm:gap-3 lg:hidden">
          {/* Hamburger Toggle Button */}
          <button
            aria-controls="sidebar"
            aria-label="Toggle navigation menu"
            onClick={(e) => {
              e.stopPropagation();
              props.setSidebarOpen(!props.sidebarOpen);
            }}
            className="flex items-center justify-center p-2 rounded-lg border border-gray-200 bg-white text-gray-700 hover:text-[#041B44] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200 lg:hidden transition-colors shadow-xs"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          <Link className="block flex-shrink-0 lg:hidden" to="/admin/dashboard">
            <img src="/images/logo.png" alt="Logo" className="h-7 w-auto invert" />
          </Link>
        </div>

        {/* Right Side: Quick Action & Controls */}
        <div className="flex items-center ml-auto gap-2 sm:gap-4">
          {/* Switch to User View / Public Site */}
          <Link
            to="/"
            className="flex items-center gap-1.5 px-2.5 py-1.5 sm:px-3 text-xs sm:text-sm font-semibold text-[#037897] bg-[#E0F2F7] hover:bg-[#bce6f1] rounded-lg transition-colors border border-[#037897]/20 whitespace-nowrap shadow-xs"
            title={t("adminNav.viewSite")}
          >
            <svg
              className="w-4 h-4 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
            <span className="hidden sm:inline">{t("adminNav.viewSite")}</span>
          </Link>

          {/* Language Switcher */}
          <div className="border-l border-r border-gray-200 px-1.5 sm:px-3 py-0.5">
            <LanguageSwitcher theme="light" />
          </div>

          {/* User Dropdown */}
          <DropdownUser />
        </div>
      </div>
    </header>
  );
};

export default Header;
